function BlockQuotes(props: any) {
    return <blockquote {...props}>{props.children}</blockquote>;
};

export default BlockQuotes;